import { useState, useRef, useEffect } from 'react';
import Popper from '@mui/material/Popper';
import { IconButton } from '@mui/material';
import { limitText } from '@/helpers/formaters';
import { ISalesmanOption } from '@/app/users/_types/salesman';

interface DropdownUserListProps {
    users: ISalesmanOption[];
}

export function DropdownUserList({ users }: DropdownUserListProps) {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                buttonRef.current &&
                !buttonRef.current.contains(event.target as Node)
            ) {
                setIsOpen(false);
            }
        }

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    function handleClick() {
        setIsOpen((prev) => !prev);
    }

    return (
        <>
            <div className="flex items-center gap-2">
                <p>{limitText(users[0].fullName, 25)}</p>
                {users.length > 1 && (
                    <div className="relative">
                        <IconButton onClick={handleClick} ref={buttonRef}>
                            <span className="material-symbols-outlined text-[--primary-color]">
                                keyboard_arrow_down
                            </span>
                        </IconButton>
                        <Popper
                            open={isOpen}
                            anchorEl={buttonRef.current}
                            placement="bottom-start"
                            style={{ zIndex: 9999 }}
                            disablePortal={false}
                        >
                            <div
                                className="flex flex-col py-2 px-2 gap-2 rounded-md bg-[--grey-color] shadow-lg min-w-[150px]"
                            >
                                {users.map((user, index) => (
                                    <p key={user.applicationUserId}>{index + 1} - {user.fullName}</p>
                                ))}
                            </div>
                        </Popper>
                    </div>
                )}
            </div>
        </>
    );
}